import { Radio, styled } from "@mui/material";

export const StyledRadio = styled(Radio)({
});